import {
    UPDATE_VERIFICATION_START,
    UPDATE_VERIFICATION_SUCCESS,
    UPDATE_VERIFICATION_ERROR,
    EMAIL_VERIFICATION_START,
    EMAIL_VERIFICATION_SUCCESS,
    EMAIL_VERIFICATION_ERROR,
    RESEND_EMAIL_VERIFICATION_START,
    RESEND_EMAIL_VERIFICATION_SUCCESS,
    RESEND_EMAIL_VERIFICATION_ERROR
} from '../constants';
import { setLoaderStart, setLoaderComplete } from './loader/loader';
import { loadAccount } from './account';
import showToaster from '../helpers/showToaster';
import {
    getUserVerifiedInfo as query, updateUserVerifiedInfoMutation, emailVerificationQuery,
    resendConfirmEmailQuery
} from '../lib/graphql';

export function disconnectVerification(item, userId) {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch({ type: UPDATE_VERIFICATION_START });

            const { data } = await client.mutate({
                mutation: updateUserVerifiedInfoMutation,
                variables: {
                    item
                },
                refetchQueries: [{ query, variables: { userId } }]
            });

            if (data?.updateUserVerifiedInfo?.status === "success") {
                dispatch({ type: UPDATE_VERIFICATION_SUCCESS });
            } else {
                dispatch({
                    type: UPDATE_VERIFICATION_ERROR,
                    payload: {
                        status: data.updateUserVerifiedInfo.status
                    }
                });
            }
        } catch (error) {
            dispatch({
                type: UPDATE_VERIFICATION_ERROR,
                payload: {
                    error
                }
            });
        }
    };
}


export function emailVerification(token, email, userId) {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch({ type: EMAIL_VERIFICATION_START });

            const { data } = await client.query({
                query: emailVerificationQuery,
                variables: {
                    token,
                    email
                },
            });

            if (data?.EmailVerification?.status === "confirmed") {
                dispatch({ type: EMAIL_VERIFICATION_SUCCESS });
                dispatch(disconnectVerification('email', userId));
                dispatch(loadAccount());
            }
        } catch (error) {
            dispatch({
                type: EMAIL_VERIFICATION_ERROR,
                payload: {
                    error
                }
            });
        }
    };
}


export function resendEmailVerification() {
    return async (dispatch, getState, { client }) => {
        try {
            dispatch({ type: RESEND_EMAIL_VERIFICATION_START });
            dispatch(setLoaderStart('resendEmailLoading'));

            const { data } = await client.query({
                query: resendConfirmEmailQuery,
                fetchPolicy: 'network-only'
            });

            if (data?.ResendConfirmEmail?.status == 200) {
                showToaster({ messageId: 'resendVerifyEmail', toasterType: 'success' })

                dispatch({ type: RESEND_EMAIL_VERIFICATION_SUCCESS });
                dispatch(setLoaderComplete('resendEmailLoading'));
            } else {
                showToaster({ messageId: 'resentEmailError', toasterType: 'error' })
                dispatch(setLoaderComplete('resendEmailLoading'));
                dispatch({
                    type: RESEND_EMAIL_VERIFICATION_ERROR,
                    payload: {
                        error: data?.ResendConfirmEmail?.errorMessage || 'Something went wrong!'
                    }
                });
            }
        } catch (error) {
            dispatch({
                type: RESEND_EMAIL_VERIFICATION_ERROR,
                payload: {
                    error
                }
            });
            dispatch(setLoaderComplete('resendEmailLoading'));
        }
    };
}
